export default __webpack_public_path__ + "static/media/95f11cc5-c68b-40e2-bc2a-530a0f3f7127.6c7e03c1.eot";